import React, { Fragment, memo } from "react";
import { useQueryClient } from 'react-query';

import useAirports from "../../../services/airports/useAirports";

const AirportIcao = (props) => {
  const airportCode = props.airportCode;
  const queryClient = useQueryClient();
  //pass a dummy key so hits to cache will return dummy record until rendering tooltip
  const airport = useAirports({ queryClient, extraKeys: [airportCode], useCache: true});

  if (Array.isArray(airport.data) && airport.data.length > 0) {
    return <Fragment>{airport.data[0].icaoCode}</Fragment>
  };

  return <Fragment>{airportCode}</Fragment>
}

export default memo(AirportIcao);